class ColorConstants {
  static EU_BLUE_COLOR = "#003399";
  static NAVY_BLUE_COLOR = "#002266";

  static LIGHT_GREY = "#f0f0f0";
}

export default ColorConstants;
